<script>
// original: https://github.com/yst138451/vue-hoverable
// License: MIT
//
// Forked to fix exception when `vnode.data` is undefined, as is the case when
// wrapping a <td>:
//
// <hoverable>
//   <td>...</td>
// </hoverable>
//
// In this scenario, a <td> vnode is allocated with an undefined data.
//
// Usage:
// Simply wrap a block of template code with <hoverable>, and a boolean var
// called 'hover' will be provided to the slot scope indicated the hover state.
//
//   <hoverable #on="{ hover }">
//     <td>
//       <line-item-external-name :hovering="hover" />
//     </td>
//   </hoverable>

export default {
  name: 'Hoverable',

  props: {
    // Delay when entering
    delay: {
      type: Number,
      required: false,
      default: 0,
    },
    // Delay when leaving
    outDelay: {
      type: Number,
      required: false,
      default: 0,
    },
    stop: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({
    // delayed status
    hover: false,

    // realtime (actual) status
    // eslint-disable-next-line vue/no-reserved-keys
    _hover: false,
  }),

  watch: {
    hover(val) {
      this.$emit('hover', val);
    },
  },

  render() {
    const vnodes = this.$scopedSlots.on({
      hover: this.hover,
    });

    if (!Array.isArray(vnodes) || vnodes.length === 0) {
      // could be empty because of a disabled row
      return vnodes;
    }

    const [vnode] = vnodes;

    if (!vnode.data) {
      vnode.data = { on: {} };
    }
    if (!vnode.data.on) {
      vnode.data.on = {};
    }

    vnode.data.on.mouseenter = (ev) => {
      if (this.stop) {
        ev.stopPropagation();
      }
      this._hover = true;
      setTimeout(() => {
        if (this._hover) {
          // set hover state after a short delay
          //
          // this is to avoid issues where the user never actually stops their
          // mouse over the element, but hover is briefly set to true anyway. At
          // best this causes some flickering of elements which react to the
          // hover state, at worst it blocks the user from interacting with the
          // true destination.
          this.hover = true;
        }
      }, this.delay);
    };

    vnode.data.on.mouseleave = (ev) => {
      if (this.stop) {
        ev.stopPropagation();
      }
      this._hover = false;
      setTimeout(() => {
        if (this._hover === false) {
          this.hover = false;
        }
      }, this.outDelay);
    };

    this.$on('onCloseModal', () => {
      this.hover = false;
      this._hover = false;
    });

    return vnode;
  },
};
</script>
